export const SUPERMARKET = '/supermarket';
export const SEARCH = '/search';

// Outside Landing Pages
export const HOME = '/';
export const TERMS_AND_CONDITIONS = '/terms-and-conditions';
export const PRIVACY_POLICY = '/privacy-policy';
export const FREQUENTLY_ASKED_QUESTIONS = '/faqs';
export const ABOUT_US = '/about-us';

export const CATEGORIES = '/categories';
export const CHECKOUT = '/checkout';
export const BRANCHES = '/branches';
export const CHECKOUT_CALLBACK = '/checkout/callback';
export const CHECKOUT_SUCCESS = '/checkout/success';
export const ASSISTED_SHOPPING = '/assisted-shopping';
export const ACCOUNT = '/account';
export const COMING_SOON = '/join-waiting-list';
export const LOGIN = '/login';
export const SOCIAL_LOGIN = '/social';
export const SIGN_UP = '/sign-up';
export const OTP = `/otp/:email`;
export const FORGOT_PASSWORD = '/forgot-password';
export const NEW_PASSWORD = '/new-password';
export const RESET_PASSWORD = `/otp/forgot-password/:email`;
export const ANY_ROUTE = '*';
export const PROFILE = 'profile';
export const ORDERS = 'orders';
export const BNPL = 'bnpl';
export const INBOX = 'inbox';
export const WALLET = 'wallet';
export const ADDRESS = 'address';
export const REVIEW = 'reviews';
export const FAVOURITE = 'favourites';
export const REFER = 'refer';
export const VERIFY_IDENTITY = 'verify-identity';
export const SUPPORT = 'support';
export const SUBSCRIPTIONS = 'subscriptions';
export const DELETE_ACCOUNT = 'delete-account';

export const PENDING_PAYMENTS = 'pending-payments';
export const BUSINESS_LOGIN = '/business/login';
export const BUSINESS_KYB = 'business/kyb';
